module.exports = __webpack_public_path__ + "img/tencent.5bc63ee4.png";